import React from "react";
import {IRouteRender} from "./route.interface";
import {IServiceFactory} from "../../service-factory.interface";
import {Check} from "../../../types/type-checking";
import {matchPath} from "react-router";

export class RouteModel implements IRouteRender {
    constructor(public readonly paths: string[],
                public readonly services: IServiceFactory,
                private readonly _renderComponent: () => React.ReactElement,) {

    }

    render(): React.ReactElement{
        return this._renderComponent()
    }


    activate(): void {
        this.services.navigation.push(this.paths[0]);
    }

    get isActive(): boolean {
        return this.services.navigation.currentRoute.equals(this);
    }

    equals(otherRoute: IRouteRender): boolean {
        if(Check.isNullOrUndefined(otherRoute)) {
            return false;
        }

        for(let p1 of this.paths) {
            for(let p2 of otherRoute.paths) {
                if(p1.toLowerCase() === p2.toLowerCase()) {
                    return true;
                }
            }
        }

        return false;
    }

    matchLocation(pathName: string): IRouteRender | null  {

        for(let path of this.paths) {
            const match = matchPath(pathName, path);
            if(match) {
                return this;
            }
        }

        return null;
    }
}
